import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
// import tableData from "../../../utils/strucuture/subAttrezzatureData.json";
import { selectError, selectIsLoading } from "../../../features/attrezzatura/attrezzaturaSlice";
import { useEffect } from "react";
import { fetchAttrezzature, getAttrezzatura } from "../../../features/attrezzatura/attrezzaturaThunk";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubAttrezzature = () => {
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const columns = [
    { field: "attrezzatura", headerName: "Tipo di attrezzatura", width: 170 },
    { field: "stabili_id", headerName: "ID", width: 70 },
    { field: "att_name", headerName: "Tipo", width: 153 },
    { field: "modello", headerName: "Marca e Modello", width: 180 },
    { field: "suprifice_coperta", headerName: "Anno di acquisto", width: 147 },
    { field: "suprificie_stoccaggio", headerName: "Stato", width: 137 },
    { field: "ultima_date", headerName: "Revisione", width: 116 },
    { field: "gps", headerName: "Frequenza manutenzione", width: 200 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
  ];

  const dispatch = useDispatch();

  const attrezzatureData = useSelector((store) => store?.attrezzature?.attrezzature);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);


  useEffect(() => {

    dispatch(fetchAttrezzature());

    dispatch(getAttrezzatura())
  }, [dispatch, selectSelectedCompany]);
  console.log(attrezzatureData, "attrezzatureData123",)

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  return (
    <>
      <div className="pageTemplate">
        {isLoading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>Error: {error}</p>}
        <Table data={attrezzatureData} columns={columns} navData={"structureAttrezzature"} deleteFunctions={"deleteAttrezzature"} />
      </div>
    </>
  );
};

export default SubAttrezzature;
